/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-curly-newline */
import Link from "next/link";
import ApnaViLogo from "assets/svgs/ApnaViLogo";
import { ApnaViLogoContainer } from "components/ResponsiveDynamicFooter/ResponsiveDynamicFooter.style";
import { isHostLaunchedMicrosite } from "utils";
import { BRANCH_APP_DOWNLOAD_CAMPAIGNS, MICROSITES } from "../../utils/constants";
import ApnaTimeLogo from "../../assets/svgs/ApnaTimeLogo";
import LinkedinLogo from "../../assets/svgs/LinkedinLogo";
import FacebookLogo from "../../assets/svgs/FacebookLogo";
import InstagramLogo from "../../assets/svgs/InstagramLogo";
import TwitterLogo from "../../assets/svgs/TwitterLogo";
import YoutubeLogo from "../../assets/svgs/YoutubeLogo";
import useBranchIoLinkGeneration from "../../utils/BranchIO";
import { getUrlPath } from "../../utils/helpers";
import {
	CategoryLinkWrapper,
	CopyrightText,
	EmptyDiv,
	FooterContent,
	FooterExtraLink,
	FooterExtraLinkContent,
	FooterImageContainer,
	FooterLinkContainer,
	FooterLogosTextContainer,
	FooterLogosWrapper,
	FooterSection,
	FooterSocialContainer,
	Hr,
	ImageContainer,
	LinkText,
	LinkWrapper,
	LogoContainer,
	PeopleImage,
	PlayStoreContainer,
	PlaystoreImage,
	PlayStoreLinkWrapper,
	SocialMediaLogosWrapper,
	Text,
} from "./ResponsiveFooter.styles";
import BrandLines from "../BrandLines";
import cityData from "../../cms/city-data";

const ResponsiveFooter = ({ source, customUtmMedium }) => {
	const [googlePlayIconUrl] = useBranchIoLinkGeneration({
		id: "",
		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.playStoreIcon,
		pageType: source,
		customUtmMedium,
		section: "Footer Google Play Icon",
	});

	const trackPageLinkClick = async (link) => {
		const Mixpanel = await import("../../utils/Mixpanel");
		Mixpanel.default.track(`${link} Click`, {
			Source: source,
			page: getUrlPath(),
			Section: "Footer",
		});
	};

	const trackJobsLinkClick = async (pageType, city) => {
		const Mixpanel = await import("../../utils/Mixpanel");
		Mixpanel.default.track(`Jobs in City Click`, {
			Source: source,
			pageType,
			city,
			page: getUrlPath(),
			Section: "Footer",
		});
	};

	const trackHireInCityClick = async (pageType, city) => {
		const Mixpanel = await import("../../utils/Mixpanel");
		Mixpanel.default.track(`Hire in City Click`, {
			Source: source,
			pageType,
			city,
			page: getUrlPath(),
			Section: "Footer",
		});
	};

	const trackJobCategoryClick = async (
		pageType,
		category,
		wfh = false,
		parttime = false
	) => {
		const Mixpanel = await import("../../utils/Mixpanel");
		Mixpanel.default.track(`Jobs in Category Click`, {
			Source: source,
			pageType,
			category,
			page: getUrlPath(),
			Section: "Footer",
			pageURL: typeof window !== "undefined" ? window.location.href : "",
			wfh,
			parttime,
		});
	};

	const trackSocialLogoClick = async (eventName) => {
		const Mixpanel = await import("../../utils/Mixpanel");
		Mixpanel.default.track(eventName, {
			Source: source,
			page: getUrlPath(),
			Section: "Footer",
		});
	};

	const hostVendor = isHostLaunchedMicrosite();
	const isHostVendorVi = hostVendor ? hostVendor === MICROSITES.VI : false;

	return (
		<FooterSection bgColor="#f5f5f5">
			<FooterContent>
				{isHostVendorVi ? (
					<ApnaViLogoContainer>
						<ApnaViLogo />
					</ApnaViLogoContainer>
				) : (
					<LogoContainer>
						<ApnaTimeLogo />
					</LogoContainer>
				)}
				<FooterLinkContainer>
					<LinkWrapper>
						<LinkText>LOOKING FOR JOBS</LinkText>
						{cityData &&
							cityData.map((city) => (
								<Text
									key={city?.name}
									onClick={() =>
										trackJobsLinkClick(
											`Jobs in ${city?.name}`,
											`${city?.name}`
										)
									}
								>
									<Link href={`/jobs/jobs-in-${city?.slug}`} passHref>
										<a rel="noopener noreferrer">
											Jobs in {city.name}
										</a>
									</Link>
								</Text>
							))}
					</LinkWrapper>
					<LinkWrapper>
						<LinkText>Start hiring</LinkText>
						{cityData &&
							cityData.map((city) => (
								<Text
									key={`Hire${city?.name}`}
									onClick={() =>
										trackHireInCityClick(
											`Hire in ${city?.name}`,
											`${city?.name}`
										)
									}
								>
									<Link
										href={`/employer/job-posting-site-in-${city?.slug}`}
										passHref
									>
										<a rel="noopener noreferrer">
											Hire in {city?.name}
										</a>
									</Link>
								</Text>
							))}
					</LinkWrapper>
					<CategoryLinkWrapper>
						<LinkText>TOP JOBS</LinkText>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs in Delivery Person Jobs",
									"Delivery Person Jobs"
								)
							}
						>
							<Link href="/jobs/delivery_person-jobs" passHref>
								<a rel="noopener noreferrer">Delivery Person Jobs</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs in Accounts / Finance Jobs",
									"Accounts / Finance Jobs"
								)
							}
						>
							<Link href="/jobs/accounts_finance-jobs" passHref>
								<a rel="noopener noreferrer">Accounts / Finance Jobs</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs in Sales (Field Work)",
									"Sales (Field Work)"
								)
							}
						>
							<Link href="/jobs/sales_field_work-jobs" passHref>
								<a rel="noopener noreferrer">Sales (Field Work)</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs in Human Resource",
									"Human Resource"
								)
							}
						>
							<Link href="/jobs/human_resource-jobs" passHref>
								<a rel="noopener noreferrer">Human Resource</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs in Backoffice Jobs",
									"Backoffice Jobs"
								)
							}
						>
							<Link href="/jobs/back_office-jobs" passHref>
								<a rel="noopener noreferrer">Backoffice Jobs</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs in Backoffice Jobs",
									"Backoffice Jobs"
								)
							}
						>
							<Link href="/jobs/business_development-jobs" passHref>
								<a rel="noopener noreferrer">Business Development</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs in Telecaller / BPO",
									"Telecaller / BPO"
								)
							}
						>
							<Link href="/jobs/telecaller_bpo-jobs" passHref>
								<a rel="noopener noreferrer">Telecaller / BPO</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Work from Home Jobs",
									"Work from Home Jobs",
									true,
									false
								)
							}
						>
							<Link href="/jobs/work_from_home-jobs" passHref>
								<a rel="noopener noreferrer">Work from Home Jobs</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Part Time Jobs ",
									"Part Time Jobs",
									false,
									true
								)
							}
						>
							<Link href="/jobs/part_time-jobs" passHref>
								<a rel="noopener noreferrer">Part Time Jobs</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Night Shift Jobs ",
									"Night Shift Jobs",
									false,
									true
								)
							}
						>
							<Link href="/jobs/night_shift-jobs" passHref>
								<a rel="noopener noreferrer">Night Shift Jobs</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Full Time Jobs ",
									"Full Time Jobs",
									false,
									true
								)
							}
						>
							<Link href="/jobs/full_time-jobs" passHref>
								<a rel="noopener noreferrer">Full Time Jobs</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs for Freshers",
									"Freshers Jobs",
									true,
									false
								)
							}
						>
							<Link href="/jobs/freshers-jobs" passHref>
								<a rel="noopener noreferrer">Freshers Jobs</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs for Women",
									"Jobs for Women",
									true,
									false
								)
							}
						>
							<Link href="/jobs/female-jobs" passHref>
								<a rel="noopener noreferrer">Jobs for Women</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs for 10th pass",
									"Jobs for 10th pass",
									true,
									false
								)
							}
						>
							<Link href="/jobs/10th_pass-jobs" passHref>
								<a rel="noopener noreferrer">Jobs for 10th pass</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackJobCategoryClick(
									"Jobs for 12th pass",
									"Jobs for 12th pass",
									true,
									false
								)
							}
						>
							<Link href="/jobs/12th_pass-jobs" passHref>
								<a rel="noopener noreferrer">Jobs for 12th pass</a>
							</Link>
						</Text>
					</CategoryLinkWrapper>
				</FooterLinkContainer>
			</FooterContent>
			<FooterExtraLink>
				<EmptyDiv />
				<FooterExtraLinkContent>
					<LinkWrapper>
						<LinkText>Links</LinkText>
						<Text onClick={() => trackPageLinkClick("Download Apna App")}>
							<Link href="/download-apna-app" passHref>
								<a rel="noopener noreferrer">Download Apna App</a>
							</Link>
						</Text>
						<Text onClick={() => trackPageLinkClick("Free Job Alerts")}>
							<Link href="/free-job-alerts" passHref>
								<a rel="noopener noreferrer">Free Job Alerts</a>
							</Link>
						</Text>
						<Text>
							<a
								href="https://careers.apna.co/"
								rel="noopener noreferrer"
								onClick={() => trackPageLinkClick("Contact Us")}
							>
								Careers
							</a>
						</Text>
						<Text onClick={() => trackPageLinkClick("Contact Us")}>
							<Link href="/contact-us" passHref>
								<a rel="noopener noreferrer">Contact Us</a>
							</Link>
						</Text>
						<Text
							onClick={() =>
								trackPageLinkClick("Vulnerability Disclosure Policy")
							}
						>
							<Link href="/vulnerability-disclosure-policy" passHref>
								<a rel="noopener noreferrer">
									Vulnerability Disclosure Policy
								</a>
							</Link>
						</Text>
					</LinkWrapper>
					<LinkWrapper>
						<LinkText>Legal</LinkText>
						<Text onClick={() => trackPageLinkClick("Privacy Policy")}>
							<Link href="/privacy" passHref>
								<a>Privacy Policy</a>
							</Link>
						</Text>
						<Text onClick={() => trackPageLinkClick("Terms & Conditions")}>
							<Link href="/user-agreement" passHref>
								<a>User Terms & Conditions</a>
							</Link>
						</Text>
						<Text onClick={() => trackPageLinkClick("Terms of Service")}>
							<Link href="/terms-of-service" passHref>
								<a>Employer Terms of Service</a>
							</Link>
						</Text>
						<Text>
							<a
								onClick={() => trackPageLinkClick("Employer FAQs")}
								href="https://employer-help-centre.apna.co/support/home"
								target="_blank"
								rel="noopener noreferrer"
							>
								Employer FAQs
							</a>
						</Text>
					</LinkWrapper>
					<LinkWrapper>
						<LinkText>Resources</LinkText>
						<Text>
							<a
								href="https://apna.co/career-central/"
								onClick={() => trackPageLinkClick("Blog")}
								target="_blank"
								rel="noopener noreferrer"
							>
								Blog
							</a>
						</Text>

						<Text onClick={() => trackPageLinkClick("Sitemap")}>
							<Link href="/api/sitemap-index.xml" passHref>
								<a rel="noopener noreferrer">Sitemap</a>
							</Link>
						</Text>
					</LinkWrapper>
					<PlayStoreLinkWrapper>
						<PlayStoreContainer
							onClick={() => {
								trackSocialLogoClick("Google Play Icon Click");
							}}
						>
							<Link href={googlePlayIconUrl} passHref>
								<a
									id="playstore-footer-link"
									rel="noopener noreferrer"
									target="_blank"
								>
									<PlaystoreImage
										id="playstore-footer-link-image"
										src="/website/play-store-badge.png"
										alt="Get it on Play Store Logo"
										height={48}
										width={160}
									/>
								</a>
							</Link>
						</PlayStoreContainer>
					</PlayStoreLinkWrapper>
				</FooterExtraLinkContent>
			</FooterExtraLink>
			<FooterSocialContainer>
				<EmptyDiv />
				<FooterLogosTextContainer>
					<FooterLogosWrapper>
						<LinkText>Follow us on social media</LinkText>
						<SocialMediaLogosWrapper>
							<a
								href="https://www.facebook.com/APNA-2386268451700180"
								target="_blank"
								id="social-footer-fb-link"
								rel="noopener noreferrer"
								onClick={() => {
									trackSocialLogoClick("Footer Facebook Icon Click");
								}}
							>
								<FacebookLogo />
							</a>
							<a
								href="https://www.linkedin.com/company/26594389/admin/"
								target="_blank"
								id="social-footer-linkedin-link"
								rel="noopener noreferrer"
								onClick={() => {
									trackSocialLogoClick("Footer LinkedIn Icon Click");
								}}
							>
								<LinkedinLogo />
							</a>
							<a
								href="https://twitter.com/apnahq"
								target="_blank"
								id="social-footer-twitter-link"
								rel="noopener noreferrer"
								onClick={() => {
									trackSocialLogoClick("Footer Twitter Icon Click");
								}}
							>
								<TwitterLogo />
							</a>
							<a
								href="https://www.instagram.com/apnahq/"
								target="_blank"
								id="social-footer-instagram-link"
								rel="noopener noreferrer"
								onClick={() => {
									trackSocialLogoClick("Footer Instagram Icon Click");
								}}
							>
								<InstagramLogo />
							</a>
							<a
								href="https://www.youtube.com/channel/UCl-retoBiPxEqXMxxIhBt7A"
								target="_blank"
								id="social-footer-youtube-link"
								rel="noopener noreferrer"
								onClick={() => {
									trackSocialLogoClick("Footer Youtube Icon Click");
								}}
							>
								<YoutubeLogo />
							</a>
						</SocialMediaLogosWrapper>
					</FooterLogosWrapper>
					<Hr />
					<CopyrightText>
						© {new Date().getFullYear()} Apna. All rights reserved
					</CopyrightText>
				</FooterLogosTextContainer>
				<FooterImageContainer>
					<ImageContainer>
						<PeopleImage
							src="/cloudinary/footer-image-a92468231747f8b656434a809fd78f4c_qprysl.png"
							alt="Apna Circle"
							height={120}
							width={240}
							showbackup={false}
						/>
					</ImageContainer>
				</FooterImageContainer>
			</FooterSocialContainer>
			<BrandLines />
		</FooterSection>
	);
};

export default ResponsiveFooter;
